import React from "react";

/**
 * Full-viewport loading indicator used as the <Suspense> fallback for lazy
 * routes and as a boot-time splash while the AuthProvider hydrates.
 */
export function LoadingScreen({ label = "Loading" }) {
  return (
    <div
      className="relative flex min-h-[100dvh] w-full items-center justify-center bg-background text-foreground"
      role="status"
      aria-live="polite"
      data-testid="loading-screen"
    >
      <div className="brand-aurora" aria-hidden="true" />
      <div className="relative z-10 flex flex-col items-center gap-4">
        <span
          className="h-9 w-9 animate-spin rounded-full border-2 border-primary/30 border-t-primary"
          aria-hidden="true"
        />
        <span className="text-sm text-muted-foreground">{label}</span>
      </div>
    </div>
  );
}

export default LoadingScreen;
